import { useEffect, useState } from 'react';
import { createContainer } from 'unstated-next';
import { useNavigate } from 'react-router-dom';
import API from 'API';

function useSignupFullForm(
  initialState = {
    username: '',
    password: '',
    phoneNumber: '',
    inviteCode: '',
    verificationCode: '',
  }
) {
  const [signupFullForm, setSignupFullForm] = useState(initialState);
  const navigate = useNavigate();

  // retrieves info from a localStorage and initializes signupFullForm state.
  // checks if we have valid token
  useEffect(() => {
    const retrievedSignupFullForm = JSON.parse(
      localStorage.getItem('signupFullForm') || '{}'
    );
    setSignupFullForm(retrievedSignupFullForm);

    API.User.checkInviteCode({
      inviteCode: retrievedSignupFullForm.inviteCode,
    }).catch(() => navigate('/'));
  }, [navigate]);

  const updateSignupFullForm = (data: { [key: string]: string }) => {
    const updatedSignupFullForm = {
      ...JSON.parse(
        localStorage.getItem('signupFullForm') || JSON.stringify(initialState)
      ),
      ...data,
    };
    localStorage.setItem(
      'signupFullForm',
      JSON.stringify(updatedSignupFullForm)
    );
    setSignupFullForm(updatedSignupFullForm);
  };

  const resetSignupFormState = () => {
    localStorage.removeItem('signupFullForm');
    setSignupFullForm(initialState);
  };

  return { signupFullForm, updateSignupFullForm, resetSignupFormState };
}

export const SignupFullForm = createContainer(useSignupFullForm);
